import { Box, Typography } from "@mui/material";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { useEffect, useState } from "react";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

export interface CustomProps {
  currentAccordion?: string;
  name: string;
  accordionSummary: JSX.Element;
  accordionDetails: JSX.Element;
  onChange: Function;
  accordionDetailsSx?: any;
  accordionSummarySx?: any;
}

const FieldCustomAccordion = (props: CustomProps) => {
  const [expand, setExpand] = useState(false);

  useEffect(() => {
    setExpand(props.name === props.currentAccordion);
  }, [props.currentAccordion, props.name]);

  return (
    <Box>
      <MuiAccordion
        disableGutters
        elevation={0}
        square
        expanded={expand}
        onChange={props.onChange(props.name)}
        sx={{
          "&:before": {
            display: "none",
          },
          border: "none",
          "&.Mui-expanded": {
            margin: 0,
          },
        }}
      >
        <MuiAccordionSummary
          expandIcon={
            <KeyboardArrowRightIcon
              sx={{
                fontSize: "1.25rem",
                transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                transform: expand ? "rotate(-90deg)" : "rotate(0deg)",
              }}
            />
          }
          sx={{
            minHeight: 48,
            padding: "8px 12px",
            "&.Mui-expanded": {
              minHeight: 48,
            },
            "& .MuiAccordionSummary-content": {
              margin: 0,
              alignItems: "center",
              "&.Mui-expanded": {
                margin: 0,
              },
            },
            "& .MuiAccordionSummary-expandIconWrapper": {
              paddingLeft: 0,
              marginLeft: 0,
            },
            ...props.accordionSummarySx,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              gap: 1,
              "& *": {
                fontSize: "inherit",
                fontWeight: "inherit",
              },
            }}
          >
            <Typography
              component="div"
              sx={{
                color: "neutral.600",
                fontWeight: "500 !important",
                fontSize: "0.8rem !important",
                lineHeight: 1.5,
                flex: 1,
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              {props.accordionSummary}
            </Typography>
          </Box>
        </MuiAccordionSummary>
        <MuiAccordionDetails sx={props.accordionDetailsSx}>
          {props.accordionDetails}
        </MuiAccordionDetails>
      </MuiAccordion>
    </Box>
  );
};

export default FieldCustomAccordion;
